export default __webpack_public_path__ + "static/media/026-trolley-cart.4d33edec.png";